import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import App from './App';
import Dashboard from './Components/Dashboard/Dashboard';
import Auth from './Components/Auth/Auth';
import PrivateRoute from './Components/Dashboard/PrivateRoute';

const NotFound = () => {
    return (
        <div className="App">
            <h1>404 Not Found</h1>
        </div>
    );
};

const Front = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(null); // 初期値を null に設定
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const authToken = localStorage.getItem('authToken');
        setIsAuthenticated(!!authToken);
        setLoading(false); // チェック完了後にロード状態を解除
    }, []);

    if (loading) {
        return <div>Loading...</div>; // 認証チェック中はローディング表示
    }

    return (
        <Router basename="/">
            <Routes>
                <Route path="/" element={<App />} />
                <Route path="/auth" element={<Auth />} />
                <Route element={<PrivateRoute isAuthenticated={isAuthenticated} />}>
                    <Route path="/dashboard" element={<Dashboard />} />
                </Route>
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Router>
    );
};

export default Front;
